export enum EStatusChatRoom {
  opened = "Opened",
  closed = "Closed",
  collapsed = "Collapsed",
}
